import { useTranslation } from '@web_opxp/features';
import { formatDateToString } from '../../../base/dateUtils';
import { ISubscriptionStatusProps } from '../../types';
import { canProductBeRestored } from '../../utils';
import RestoreButton from '../RestoreButton';
import SubscriptionStatusBadge from '../SubscriptionStatusBadge';
import ProductLabel from './labels/ProductLabel';
import SubscriptionLabel from './labels/SubscriptionLabel';

export default function NonRenewingStatus({ subscription }: Readonly<ISubscriptionStatusProps>) {
  const { productId, id, createdAt, expiresAt, isTerminable, secondProductId, status } = subscription;
  const { language } = useTranslation();

  const fCreatedAt = formatDateToString(createdAt, language);
  const fExpiresAt = formatDateToString(expiresAt, language);

  // subscription can be restored if its product id is included in the list from remote config
  const canBeRestored = canProductBeRestored(productId);
  const showRestoreButton = isTerminable && canBeRestored;

  return (
    <>
      <SubscriptionStatusBadge status={status} />
      <ProductLabel productId={productId} family={!!secondProductId} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.Started" value={fCreatedAt} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.Expire" value={fExpiresAt} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.NextCharge" value="-" />
      <RestoreButton id={id} show={showRestoreButton} />
    </>
  );
}
